export const DETAIL_SALE_LIST_REQUEST = "DETAIL_SALE_LIST_REQUEST"; 
export const DETAIL_SALE_LIST_SUCCESS = "DETAIL_SALE_LIST_REQUEST_SUCCESS";

export const READ_DETAIL_SALE = 196011;
